var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSpace4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1654,
    height: 50,
    viewBox: "0 0 1654 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1654 0H-1V50H1614L1654 0Z",
    fill: "#E3F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSpace4);
export default __webpack_public_path__ + "static/media/shape_space_4.7ef2c37faee82a05c82a7e8a1460fa1e.svg";
export { ForwardRef as ReactComponent };